import {ProviderIdentita} from './collegamento-account.api';

export interface ClaimsIdentitaTemporanea {
  alias?: string;
  nome?: string;
  cognome?: string;
  email?: string;
  telefono?: string;
}

/**
 * Legge dal payload del token (solo decodifica, nessuna verifica di firma: non serve, il token
 * lo valida il BE) l'alias dell'IdP (`identity_provider`, serve a rifare il login con
 * `SpidAuthService.login(alias)`) e i dati per precompilare la segnalazione: nome e cognome sempre,
 * email e cellulare solo se l'IdP li ha inviati e Keycloak li mette nel token (`email`,
 * `phone_number` OIDC o `mobilePhone` SPID). Sono solo proposte: il cittadino può cambiarle.
 * Restituisce `{}` se il token non è decodificabile: l'assenza si propaga, nessun valore finto.
 */
export function leggiClaimsIdentitaTemporanea(token: string | null | undefined): ClaimsIdentitaTemporanea {
  if (!token) {
    return {};
  }
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return {};
    }
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '==='.slice((normalized.length + 3) % 4);
    const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
    const claims = JSON.parse(new TextDecoder().decode(bytes)) as Record<string, unknown>;
    const str = (v: unknown): string | undefined => (typeof v === 'string' && v ? v : undefined);
    return {
      alias: str(claims['identity_provider']),
      nome: str(claims['given_name']),
      cognome: str(claims['family_name']),
      email: str(claims['email']),
      telefono: str(claims['phone_number']) ?? str(claims['mobilePhone']),
    };
  } catch {
    return {};
  }
}

/**
 * Etichetta del marchio (non tradotta) ricavata dall'alias dell'IdP, usata solo quando il BE
 * non ha ancora risposto con `provider`. Gli alias CIE contengono "cie" (es. `cieid-testing`);
 * ogni altro alias è uno SPID.
 */
export function providerDaAlias(alias: string | null | undefined): ProviderIdentita {
  return /cie/i.test(alias ?? '') ? 'CIE' : 'SPID';
}
